import { formatNumber } from '@progress/kendo-intl';
import { GridColumnMenuFilter} from "@progress/kendo-react-grid";
import moment from 'moment';



export const GridPercentageColumn=(e)=>{
    const FieldName=e.field
    const value=`${e.dataItem[FieldName]}`*1;
    return <td colSpan="1" className="k-table-td GridNumberCells" role="gridcell" aria-selected="false">
    {
      formatNumber(value,{style:'percent',minimumFractionDigits:2})
    }
    </td>
  }

  export const gridDefaultColumnMenu=(props)=>{
    return <div>
    <GridColumnMenuFilter {...props} expanded={true} />
  </div>
  }
  export const getDateFormatted=(params)=>{
    const isoDate = params.value;
    const formattedDate = moment(isoDate).format('MM-DD-YYYY');
    return formattedDate;
};

